import { Vector } from "@dreamhub/designsystem/icons";
import IconContainer from "@/components/ui/icon-container";
import Text from "@/components/ui/text";
import { cn } from "@/utils/utils";

interface Props {
  isExpanded: boolean;
  label: string;
}

const LogoWithText: React.FC<Props> = ({ isExpanded, label }) => {
  return (
    <div className="flex items-center gap-2 p-4">
      <IconContainer color="current" size="5">
        <Vector />
      </IconContainer>
      <div
        className={cn(
          "flex items-center gap-4 overflow-hidden",
          isExpanded ? "opacity-100 max-w-full" : "opacity-0 max-w-0"
        )}
      >
        <Text as="span" variant="lgSubtitle">
          {label}
        </Text>
      </div>
    </div>
  );
};

export default LogoWithText;
